<template>
  <div id="wrapper">
    <nav
      class="navbar navbar-default navbar-static-top"
      role="navigation"
      style="margin-bottom: 0"
    >
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link class="navbar-brand" to="/">КОШ</router-link>
      </div>
      <ul class="nav navbar-top-links navbar-right">
        <li @click="logout" :class="logoutItemCss">
          <a> <i class="fa fa-sign-out fa-fw"></i> Выход </a>
        </li>
      </ul>
      <div class="navbar-default sidebar" role="navigation">
        <div class="sidebar-nav navbar-collapse">
          <ul class="nav" id="side-menu">
            <li
              v-for="item in navigationItems.firstLevel"
              :key="item.link"
              v-if="userHasPermission(item)"
            >
              <router-link :to="item.link">
                {{ item.label }}
              </router-link>
            </li>
            <li>
              <a>Склад<span class="fa arrow"></span></a>
              <ul class="nav nav-second-level">
                <li
                  v-for="item in navigationItems.secondLevel"
                  :key="item.link"
                >
                  <router-link :to="item.link">{{ item.label }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
import { navigationItems } from "@/_shared/constants";
import { useRoleIdentifier, useNotification } from "@/_shared/mixins";
import httpClient from "@/_shared/http-client";
import store from "@/_shared/store";
export default {
  mixins: [useRoleIdentifier, useNotification],
  data() {
    return {
      navigationItems,
      isSending: false,
    };
  },
  computed: {
    logoutItemCss() {
      const classes = ['item'];
      if (this.isSending) {
        classes.push('item_disabled');
      };
      return classes;
    },
  },
  methods: {
    async logout() {
      this.isSending = true;
      await httpClient.delete('/auth/logout')
        .then(() => {
          this.showSuccessNotification('Вы успешно вышли из аккаунта');
          store.commit('setRole', null);
          localStorage.removeItem('token');
          this.$router.push('/login');
        })
        .finally(() => {
          this.isSending = false;
        });
    },
  },
};
</script>

<style scoped>
.item_disabled {
  opacity: 0.55;
  pointer-events: none;
}
@media (max-width: 767px) {
  #wrapper > nav > ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    padding-bottom: 2em;
  }
  .nav__link_workshift-menu {
    padding-top: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/layouts/DefaultLayout.vue